import classNames from 'classnames'

import { TEST_LOCATORS } from '@src/constants/test-locators'
import { BreadCrumb } from '@src/quince-components/src'
import Directory from '@src/quince-site-common/src/domains/Directory'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

import { IContentfulCollection } from '../../types/ContentfulCollectionService.types'

import SubCategoryLinksList from './subCategoryLinksList'
import useGetSubCategoryConfig from './subCategoryLinksList/useGetSubCategoryConfig'
import styles from './subCategoryList.module.scss'

export interface LinkGroupProps {
  buttons?: IContentfulCollection[] | undefined
  className?: string
}

interface SubCategoryListProps {
  // buttonGroup: Omit<ButtonGroupProps, 'sendEventOnButtonClick'>
  directory: Directory
  linkGroup: LinkGroupProps
}

const SubCategoryList = ({ linkGroup, directory }: SubCategoryListProps) => {
  const { viewNumber, breadCrumbListClass = '' } = useGetSubCategoryConfig()
  const { deviceType } = useDeviceInfo()
  const isMobile = deviceType === DEVICE_TYPES.MOBILE
  const hideBreadCrumb = isMobile && directory.paths.length <= 1
  const noLinkGroup = isMobile && !linkGroup.buttons?.length

  return (
    <div
      className={classNames(styles.container, {
        [`${styles.hidden_breadcrumb}`]: hideBreadCrumb,
        [`${styles.no_linkgroup}`]: noLinkGroup,
      })}
      data-active-view={viewNumber}
      id="sub-category-list-header"
    >
      <div className={styles.container__text} data-testid={TEST_LOCATORS.COLLECTION_BREADCRUMB}>
        {/** Remove breadcrumb for mobile web and for "All" pages only */}
        {!hideBreadCrumb && <BreadCrumb directory={directory} breadCrumbListClass={breadCrumbListClass} />}
      </div>
      <SubCategoryLinksList linkGroup={linkGroup} />
    </div>
  )
}

export default SubCategoryList
